import {isFeatureEnabled} from '@github-ui/feature-flags'

// Single gate for the For You refresh stack. To graduate, delete the flag and this helper,
// then remove flag-off branches and their Legacy adapters.
export function isForYouRefreshEnabled() {
  return isFeatureEnabled('prs_overview_for_you_refresh')
}
